import React from 'react';
import { useLoaderData } from 'react-router-dom';
import PageHeader from '@shared/PageHeader';
import ThirdPartyApiLogShow from '@shared/third_party_api_logs/ThirdPartyApiLogShow';

export default function OperatorThirdPartyApiLogsShow() {
  const log = useLoaderData();

  return (
    <div>
      <PageHeader items={['integration_logs', 'integration_logs.api_logs', { label: log?.id?.slice(0, 8) }]} />
      <ThirdPartyApiLogShow log={log} />
    </div>
  );
}
